// extracted by mini-css-extract-plugin
module.exports = {"primaryThemeColor":"#547aa8","primaryTextColor":"#303030"};